<!-- //
图片展示
@auth xuyd
@date 2024-05-05
//-->
<template>
  <el-image
      :style="{width: width, height: height}"
      :src="value"
      :fit="fit"></el-image>
</template>

<script>


export default {
  name: 'CompImageView',
  data() {
    return {}
  },
  props: {
    value: [String],
    width: {
      type: String,
      default: '50px'
    },
    height: {
      type: String,
      default: '50px'
    },
    fit: {
      type: String,
      default: 'fit'
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  }
}
</script>

<style lang="less" scoped>
.card {
}
</style>
